import { render, staticRenderFns } from "./ColorsEditorComponent.vue?vue&type=template&id=5ce2b8d6&scoped=true"
import script from "./ColorsEditorComponent.vue?vue&type=script&lang=js"
export * from "./ColorsEditorComponent.vue?vue&type=script&lang=js"
import style0 from "./ColorsEditorComponent.vue?vue&type=style&index=0&id=5ce2b8d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce2b8d6",
  null
  
)

export default component.exports